import { observer } from "mobx-react-lite";
import React, { useState } from "react";
import { Accordion, Grid, Header, Icon, Image, Label, Message, Segment } from "semantic-ui-react";
import styles  from "../../../../Assessment/AssessmentInfoSlideControls/LearnMoreTemplate.module.css"

const cdnRoute = process.env.REACT_APP_CDN_ROUTE + "/medical/";
const iconRoute = process.env.REACT_APP_CDN_ROUTE + "/icons/";

const EvaluateDrivingLearnMore: React.FC = () => {
  const [activeAccordionIndexes] = useState([0, 1]);

  const renderAccordionPlans = () => {
    return (
      <>      
        <Grid stackable className={styles.learnMoreFullDiv} >
          <Grid.Row columns='equal' stretched className={styles.highlightsItemRow} >
            <Grid.Column stretched className={`${styles.highlightsItemColumn} ${styles.hghlgtItemColMiddle}`} >
              <Segment raised className={styles.highlightsItemWhiteBG} >  
                <div style={{width: '100%', height: '100%', display: "inline-block"}}>
                    <p className={styles.learnMoreAccordionText} style = {{ marginBottom: `.75em`, }}> <br/>
                        These assessments typically fall into two categories: <b>driving skills evaluations</b> and  
                        <b> clinical driving assessments</b>. 
                        <br/><br/>
                        Results from both can help determine if the older adult is safe to continue driving, address 
                        issues that may benefit by offering additional training or special adaptive equipment, or 
                        reveal the older adult is no longer safe to operate a motor vehicle. </p>
                </div>
              </Segment>   
            </Grid.Column>
          </Grid.Row>
          <Grid.Row stretched columns='equal' className={styles.highlightsItemRow} >
            <Grid.Column stretched className={`${styles.highlightsItemColumn} ${styles.hghlgtItemColMiddle}`} >
              <Segment raised className={styles.highlightsItemWhiteBG} >  
                <Header as='h2' icon className={styles.highlightsItemHeader} >
                  <Image src={`${iconRoute}TransportationIcon.png`} className={styles.highlightsItemHeaderImgIcon} />
                  <p className={styles.highlightsItemHeaderTitle} >DRIVING SKILL ASSESSMENT</p>
                  <Header.Subheader >  
                    <p className={styles.highlightsItemSubHeaderText} >This usually involves an evaluation of the 
                        older adult's driving skills and then a recommendation for further drivers' training, if 
                        necessary. This can be done by local driving schools in your area or by contacting your 
                        local AAA club or DMV for recommendations. </p> 
                  </Header.Subheader>
                </Header>
              </Segment>  
            </Grid.Column>
            <Grid.Column stretched className={`${styles.highlightsItemColumn} ${styles.hghlgtItemColMiddle}`} >
              <Segment raised className={styles.highlightsItemWhiteBG} >  
                <Header as='h2' icon className={styles.highlightsItemHeader} >
                  <Image src={`${iconRoute}MedicalAssessment.png`} className={styles.highlightsItemHeaderImgIcon} />
                  <p className={styles.highlightsItemHeaderTitle} >CLINICAL DRIVING ASSESSMENT </p>
                  <Header.Subheader > 
                    <p className={styles.highlightsItemSubHeaderText} >A provider will look at the older adult's medical 
                        history to determine any medical issues that may cause a driving performance deficit. The 
                        American Occupational Therapy Association (AOTA) has 
                        <span><b>
                            <a href="https://myaota.aota.org/driver_search/index.aspx/index.aspx"
                            target="_blank"
                            rel="noreferrer" > a national database of driving programs and specialists{" "} </a>
                            </b></span>
                        that can assist with this. If not, reach out to your local rehabilitation hospital's 
                        OT department for recommendations.</p>
                  </Header.Subheader>
                </Header>
              </Segment>  
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </>
    );
  };


  const accordions = [
    { key: 'plans',
      index: 0,
      title: { 
        icon: <Icon name='dropdown' className={styles.learnMoreAccordionLabelTitleIcon} />, 
        content: <Label className={styles.learnMoreAccordionLabelTitle} > What Does a Professional Driving Assessment Entail? </Label> },
      content: { 
        content: (<Message className={styles.learnMoreAccordionMessageBox} content={renderAccordionPlans()}/>)
      }
    }
  ];

  
  return (
    <>
      <Segment className={styles.learnMoreBackgroundImg} style = {{ backgroundImage: `url(${cdnRoute}EvalDrivingLearnMore2.jpg)`, }}>
        <div className={styles.learnMoreModalContent}>

          <div className={styles.learnMoreAccordionFullDivGrid} >
            <div className={styles.learnMoreAccordionFullDiv} >
              <Accordion panels={accordions} exclusive={false}
                    className={styles.learnMoreModalAccordionGroup}
                    defaultActiveIndex={activeAccordionIndexes} />
            </div> 
          </div>  

        </div>
      </Segment>      
    </>
  );  
};

export default observer(EvaluateDrivingLearnMore);
